// extracted by mini-css-extract-plugin
export default {"line":"qCz09irxdRLxSBD_jAkw","label":"Tr8wm0tYBEWqe6VphSIg"};